export default __webpack_public_path__ + "static/media/profile.c646a326.svg";